export interface ReplyToCCAddress {
  id: number;
  userName: string;
  name: string;
  userType: number;
  userTypeName: string;
}

export interface ReplyToCCAddressResponse {
  isSuccess: boolean;
  statusCode: number;
  valueResult: ReplyToCCAddress[];
}

export interface SaveEmailNotificationSettingsRequest {
  moduleId: number;
  displayName: string;
  ccAddress: string;
  replyToAddress: string;
}

export interface EmailNotificationSetting {
  id: number;
  moduleId: number;
  moduleName: string;
  displayName: string;
  ccAddress: string;
  replyToAddress: string;
  tenantId: string;
  createdDate: string;
  isDeleted: boolean;
  createdBy: string;
  updatedBy: string;
}
